import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getEmoji } from "../../../api/user";

export const fetchEmoji = createAsyncThunk("fetchEmoji", async () => {
  const res = await getEmoji();
  return res;
});


const initialState = {};

const emojiSlice = createSlice({
  name: "emoji",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmoji.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchEmoji.fulfilled, (state, action) => {
        state.isLoading = false;
        state.response = action.payload;
      })
      .addCase(fetchEmoji.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
  },
});
export const { reset } = emojiSlice.actions;
export { emojiSlice };
